import { UserSettingsTypes } from './types';
import React, { createContext, FC } from 'react';
import useAccountSettings from './index';

// @ts-ignore
export const UserSettingsContext = createContext<UserSettingsTypes>({});

export const UserSettingsProvider: FC = ({ children }) => {
  const {
    getShippingAddress,
    updateShippingAddress,
    loadingShippingInfo,
    savingShippingInfo,
    shippingAddress,
    invalidAddress,
    savedShippingInfo,
    getTestHistory,
    loadingTestsHistory,
    testsHistory,
    testsHistoryPagination,
    resetState,
  } = useAccountSettings();

  return (
    <UserSettingsContext.Provider
      value={{
        getShippingAddress,
        updateShippingAddress,
        loadingShippingInfo,
        savingShippingInfo,
        shippingAddress,
        invalidAddress,
        savedShippingInfo,
        getTestHistory,
        loadingTestsHistory,
        testsHistory,
        testsHistoryPagination,
        resetState,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};
